var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table b-table table-hover table-bordered" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.list, function(item) {
            return _c("tr", { key: item.id }, [
              _c("td", [
                _vm._v(
                  _vm._s(item.hasComission ? "OK" : "Sem comissão no período")
                )
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(item.start ? _vm.formatDate(item.start) : ""))
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(item.end ? _vm.formatDate(item.end) : ""))
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/user/${item.billing.userId}/installation/${item.billing.installationId}/billing/edit/${item.billing.billingId}/${item.billing.accountId}`
                    }
                  },
                  [_vm._v("Fatura " + _vm._s(item.billing.billingId))]
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(_vm._f("currency")(item.billing.value)))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.value ? item.value : 0) + " %")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm._f("currency")(item.computedValue)))])
            ])
          }),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { colspan: "5" } }),
            _vm._v(" "),
            _c("td", [
              _c("strong", [
                _vm._v(_vm._s(_vm._f("currency")(_vm.getTotalValue())))
              ])
            ]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", [
              _c("strong", [
                _vm._v(_vm._s(_vm._f("currency")(_vm.getTotalComission())))
              ])
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Situação comissão")]),
        _vm._v(" "),
        _c("td", [_vm._v("Consumidor")]),
        _vm._v(" "),
        _c("td", [_vm._v("Início")]),
        _vm._v(" "),
        _c("td", [_vm._v("Fim")]),
        _vm._v(" "),
        _c("td", [_vm._v("Número fatura")]),
        _vm._v(" "),
        _c("td", [_vm._v("Valor fatura")]),
        _vm._v(" "),
        _c("td", [_vm._v("Comissão")]),
        _vm._v(" "),
        _c("td", [_vm._v("Valor comissão")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }